const PopupBG = document.querySelector(".popup-bg");
const Popup = document.querySelector("#popup-contact-office");
const closeBttn = document.querySelector(".popup__bttn-close");
const windowWidth = window.innerWidth;
const documentWidth = document.body.clientWidth;

const showPopup = (data) => {
	if (Popup) {
		Popup.classList.add("show");
		PopupBG.classList.add("show");
		document.body.classList.add("scroll-disable");
		document.body.style.paddingRight = windowWidth - documentWidth + "px";

		const PopupCountry = Popup.querySelector(".popup__content-title");
		const PopupLocation = Popup.querySelector(".popup__content-address");
		const PopupPhonesList = Popup.querySelector(".popup__phones");
		const PopupContactsList = Popup.querySelector(".popup__contacts");
		const PopupMap = Popup.querySelector(".popup__map iframe");

		if (PopupCountry) PopupCountry.textContent = data.country;
		if (PopupLocation) {
			PopupLocation.href = data.mapLink;
			PopupLocation.textContent = data.address;
		}

		if (PopupPhonesList) {
			PopupPhonesList.innerHTML = "";
			data.phones.forEach((phone) => {
				const listItem = document.createElement("li");
				listItem.innerHTML = `${phone.label} <a href="tel:${phone.number}">${phone.text}</a>`;
				PopupPhonesList.appendChild(listItem);
			});
		}

		if (PopupContactsList) {
			PopupContactsList.innerHTML = "";
			data.contacts.forEach((contact) => {
				const listItem = document.createElement("li");
				listItem.innerHTML = `${contact.label} <a href="mailto:${contact.email}">${contact.text}</a>`;
				PopupContactsList.appendChild(listItem);
			});
		}

		if (PopupMap) {
			PopupMap.src = data.mapEmbedLink;
		}
	}
};

const hidePopup = () => {
	PopupBG.classList.remove("show");
	document.body.classList.remove("scroll-disable");
	Popup.classList.remove("show");
	document.body.style.paddingRight = 0;
};

document.querySelectorAll(".offices__item").forEach((officeItem) => {
	officeItem.addEventListener("click", () => {
		const data = {
			country: officeItem.querySelector(".offices__item-country").textContent.trim(),
			address: officeItem.querySelector(".offices__item-location").textContent.trim(),
			mapLink: officeItem.querySelector(".offices__item-location").href,
			mapEmbedLink: officeItem.querySelector("#iframe_src").textContent,
			phones: Array.from(officeItem.querySelectorAll("ul li a[href^='tel']")).map((phone) => ({
				number: phone.getAttribute("href").replace("tel:", ""),
				text: phone.textContent.trim(),
				label: phone.parentElement.firstChild.textContent.trim(),
			})),
			contacts: Array.from(officeItem.querySelectorAll("ul li a[href^='mailto']")).map((contact) => ({
				email: contact.getAttribute("href").replace("mailto:", ""),
				text: contact.textContent.trim(),
				label: contact.parentElement.firstChild.textContent.trim(),
			})),
		};
		showPopup(data);
	});
});

PopupBG.addEventListener("click", hidePopup);
if (closeBttn) closeBttn.addEventListener("click", hidePopup);
